<template>
  <el-row>
    <el-form :model="wxNoticeSettingForm"
             ref="wxNoticeSettingRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction=""
             editAction="businessIntranet/settingWxNoticeSetting.action"
             selectAction="businessIntranet/selectWxNoticeSetting.action"
             label-width="150px"
             style="width:50%"
             v-form>
      <el-form-item label="车源接收地区:" >
          <city-cascader  @onAreaChanged="setSecondReceiveCity" ref="setSecondReceiveCityCasCader" ></city-cascader>
      </el-form-item>
      <el-form-item label="求购接收地区:">
        <city-cascader @onAreaChanged="setSearchReceiveCity" ref="setSearchReceiveCityCasCader" ></city-cascader>
      </el-form-item>
      <el-form-item label="线索接收地区:">
        <city-cascader @onAreaChanged="setClueCarReceiveCity" ref="setClueCarReceiveCityCasCader"></city-cascader>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import cityCascader from '@/components/cityCascader'
export default {
  name: 'wxNoticeSetting',
  extends: BasicPager,
  components: { cityCascader },
  data: function () {
    return {
      rules: {},
      wxNoticeSettingForm: {
        id: null,
        secondReceiveCity: null,
        searchReceiveCity: null,
        clueCarReceiveCity: null
      }
    }
  },
  created () {
    this.wxNoticeSettingForm.id = this.$route.query.businessId
  },
  methods: {
    setSecondReceiveCity: function (data) {
      this.wxNoticeSettingForm.secondReceiveCity = data.join(',')
    },
    setSearchReceiveCity: function (data) {
      this.wxNoticeSettingForm.searchReceiveCity = data.join(',')
    },
    setClueCarReceiveCity: function (data) {
      this.wxNoticeSettingForm.clueCarReceiveCity = data.join(',')
    },
    onFilterParams: function (params) {
    },
    onSelectInfo: function (dataInfo) {
      let that = this
      // setTimeout(() => console.log(`Hello `), 1000 * 5)
      that.$nextTick(function () {
        let setSecondReceiveCityCasCader = that.$refs['setSecondReceiveCityCasCader']

        if (setSecondReceiveCityCasCader) {
          setSecondReceiveCityCasCader.setValue(dataInfo.datas.secondReceiveCity)
        }

        let setSearchReceiveCityCasCader = that.$refs['setSearchReceiveCityCasCader']
        if (setSearchReceiveCityCasCader) {
          setSearchReceiveCityCasCader.setValue(dataInfo.datas.searchReceiveCity)
        }
        let setClueCarReceiveCityCasCader = that.$refs['setClueCarReceiveCityCasCader']
        if (setClueCarReceiveCityCasCader) {
          setClueCarReceiveCityCasCader.setValue(dataInfo.datas.clueCarReceiveCity)
        }
      })
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
